export default "__VITE_ASSET__DLrNmNuB__"